import { Box, Stack, Typography } from '@mui/material';
import { type FallbackProps } from 'react-error-boundary';
import { PageFooter } from '@/components/Common/PageFooter';
import { ErrorFallbackSupportLink } from '@/components/Error/ErrorFallbackSupportLink';
import { cdnStaticPath } from '@/helpers/url';
import { ErrorContent, ErrorImage, ErrorContainer, ErrorCodeBox } from './styled-components';

export function AppRootErrorFallback(props: FallbackProps) {
  return (
    <>
      <ErrorContainer>
        <ErrorImage src={cdnStaticPath('static/images/not-found-illustration.svg')} />
        <ErrorContent>
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Typography
                component="h2"
                variant="h3"
                sx={{
                  color: 'text.primary',
                }}
              >
                Glitch in the Vector Field
              </Typography>
              <Typography
                component="h3"
                variant="subtitle1"
                sx={{
                  color: 'text.primary',
                }}
              >
                A brief anomaly was detected here. We've logged the error
                <wbr /> and our crew is on the case.
              </Typography>
            </Stack>
            <ErrorCodeBox>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  whiteSpace: 'pre-wrap',
                  fontFamily: 'monospace',
                }}
              >
                {String(props.error)}
              </Typography>
            </ErrorCodeBox>
            <Typography
              component="p"
              variant="caption"
              sx={{
                color: 'text.secondary',
                fontSize: '0.8rem',
              }}
            >
              Please try again in a few moments. If this issue persists,{' '}
              <ErrorFallbackSupportLink>contact support</ErrorFallbackSupportLink> and provide the page URL.
            </Typography>
          </Stack>
        </ErrorContent>
      </ErrorContainer>
      <Box sx={{ pt: 1, pb: '0.1px' }}>
        <PageFooter />
      </Box>
    </>
  );
}
